import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";

import { Box } from "../../../../../dtos/box";
import { Event } from "../../../../../dtos/event";
import { AjaxResult } from "../../../../../enums/ajaxResult";
import { LogFilterRequest } from "../../../../../rest/requestObjects/eventLogRequest";
import { useApi } from "../../../../useApi";

export function useBoxEvents(box: Box, request: LogFilterRequest): {
    isLoading: boolean,
    events: Event[],
    numberOfPages: number,
} {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();

    const [isLoading, setIsLoading] = useState(false);
    const [events, setEvents] = useState<Event[]>([]);
    const [numberOfPages, setNumberOfPages] = useState(0);

    useEffect(() => {
        const abortController = new AbortController();
        setIsLoading(true);
        boxApi.getEvents(
            box.id,
            request,
            abortController,
        ).then((r) => {
            if (r.result === AjaxResult.Success && r.data) {
                setEvents(r.data.events);
                setNumberOfPages(r.data.numberOfPages);
                setIsLoading(false);
            } else if (r.result !== AjaxResult.Cancelled) {
                enqueueSnackbar("Failed to load box events", { variant: "error" });
                setIsLoading(false);
            }
        });
        return () => abortController.abort();
    }, [box, request, boxApi, enqueueSnackbar]);

    return {
        isLoading,
        events,
        numberOfPages,
    };
}
